import React, { useEffect, useMemo, useState } from 'react'
import Switch from 'react-switch';
import Select from 'react-select';
import { useDispatch } from 'react-redux';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { ClearLocalStorage, GetLocalStorage } from '../../../../commonClass/Session';
import { getAllData, postUsersData, verifytoken } from '../../../../../services/ApiCallingUserServices';
import { loaderActions } from '../../../../../_actions/loader.actions';
import { ExportExcel } from '../../../../commonClass/ExportExcel';
import { CustomModal } from '../../../../../customControl/CustomModal';
import { ConfirmationModal } from '../../../../../customControl/ConfirmationModal';
import CustomTable from '../../../../../customControl/CustomTable';
import { fetchIp } from '../../../../commonClass/CommonFunctions';
import CommonFilter from '../../../../../customControl/CommonFilter';
import { isEmpty, isValidURL } from '../../../../commonClass/CommonValidation';

const { RangePicker } = DatePicker;

const APIConfigurationActivity = ({ useradd, useredit, userexport }) => {
    const dispatch = useDispatch();
    const userId = GetLocalStorage();

    const [dropdownData, setDropdownList] = useState(
        {
            supplierList: [],
            operatorList: [],
        }
    );
    const [getDataList, setGetListData] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [editDisable, setEditDisable] = useState(false);
    const [formError, setFormError] = useState({});
    const [activeId, setActiveId] = useState(true);
    const [modalShow, setModalShow] = useState(false);
    const [show, setShow] = useState(false);
    const [validapi, setValidApi] = useState(false)
    const [isDisabledValidbtn, setIsDisableValidbtn] = useState(true)
    const [downloadDate, setDowloadDate] = useState({
        startDate: '',
        endDate: ''
    })

    const [searchvalue, setSearchValue] = useState('');
    const [searchby, setSerachBy] = useState('All');
    const [searchDisabled, setSearchDisable] = useState(false);

    const [formValue, setFormValue] = useState({
        APIConfigurationId: 0,
        SupplierId: 0,
        URL: '',
        Key: '',
        SecretKey: '',
        IsActive: false,
        UserId: 0,
        OperatorId: [],
        type: 'add',
        TravelCategoryId: 1  // change according to Activity ID
    })

    const getoperatorlist = async () => {
        const operatorlist = await getAllData('/master/v1/getoperatorlist');
        if (operatorlist?.status) {
            setDropdownList({
                supplierList: operatorlist?.data?.supplierList?.map(el => ({
                    label: el?.SupplierName,
                    value: el?.SupplierId
                })),
                operatorList: operatorlist?.data?.operatorList?.map(el => ({
                    label: el?.AirlineName,
                    value: el?.AirlineID
                }))
            });
        }
        else {
            setDropdownList({
                supplierList: [],
                operatorList: [],
            })
        }
    }

    const getapiconfigurationlist = async () => {
        const apiconfigurationlist = await getAllData(`/master/v1/getapiconfigurationlist?travelcategoryId=1`);
        if (apiconfigurationlist?.status) {
            apiconfigurationlist?.data?.map((obj) => {
                obj.CreatedDateFormat = formatDate(obj?.CreatedDate)
                return obj;
            })
            setGetListData(apiconfigurationlist?.data);
            setFilterData(apiconfigurationlist?.data);
        }
        else {
            setGetListData([]);
            setFilterData([]);
        }
    }

    const handleOnChange = (name, value) => {
        setFormError({});
        setEditDisable(false);
        setIsDisableValidbtn(false)
        if (name === 'OperatorId') {
            setFormValue({ ...formValue, [name]: value?.map(val => val.value) });
        }
        else {
            setFormValue({ ...formValue, [name]: value });
        }
    }

    const handleisActive = (e) => {
        if (formValue?.type === 'add') {
            formValue.IsActive = e
            setActiveId(!activeId)
            setFormError({});
        }
        else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (e) => {
        if (e === true) {
            formValue.IsActive = !activeId
            setActiveId(!activeId)
            setFormError({});
            setEditDisable(false);
        }
        setModalShow(false);
    }

    const validationData = (type = null) => {
        let errorMessages = {};
        let isError = true;

        if (type !== "Authentication") {
            if (formValue?.SupplierId === 0) {
                errorMessages['SupplierId'] = 'Cannot leave blank, input is mandatory.'
                isError = false;
            } else if (formValue?.SupplierId > 0 && formValue?.type === 'add' && filterData?.some((val) => val?.SupplierId === formValue?.SupplierId)) {
                errorMessages['SupplierId'] = 'Duplicate Supplier. Please enter a unique Supplier.'
                isError = false;
            }

            if (!formValue?.OperatorId?.length) {
                errorMessages['OperatorId'] = 'Cannot leave blank, input is mandatory.'
                isError = false;
            }
        }
        if (isEmpty(formValue?.URL)) {
            errorMessages['URL'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        } else if (!isValidURL(formValue?.URL)) {
            errorMessages['URL'] = 'Please enter a valid URL.'
            isError = false;
        }

        if (isEmpty(formValue?.Key)) {
            errorMessages['Key'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        }
        if (isEmpty(formValue?.SecretKey)) {
            errorMessages['SecretKey'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        }
        setFormError(errorMessages);
        return isError;
    }

    const validate = async () => {
        const isValid = validationData("Authentication");
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            if (isValid) {
                const userip = await fetchIp();
                if (userip?.status) {
                    const colle = {
                        URL: formValue?.URL,
                        Key: formValue?.Key,
                        SecretKey: formValue?.SecretKey,
                        EndUserIp: userip.data
                    }
                    dispatch(loaderActions.start());
                    const validatecredentials = await postUsersData('/master/v1/validatecredentials', colle);
                    if (validatecredentials?.status) {
                        dispatch({ type: 'ALERTING', message: validatecredentials?.message })
                        setValidApi(true)
                        dispatch(loaderActions.end());
                        setIsDisableValidbtn(true)
                    }
                    else {
                        dispatch(loaderActions.end());
                        setValidApi(false)
                        dispatch({ type: 'ALERTING', message: validatecredentials?.message })
                        return;
                    }
                }
                else {
                    dispatch({ type: 'ALERTING', message: 'Something went wrong, Please try again!' });
                }
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
        dispatch(loaderActions.end());
    }

    const handleAddUpdateData = async () => {
        const isValid = validationData();
        if (isValid) {
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                dispatch(loaderActions.start());
                const data = await postUsersData('/master/v1/insertorupdateapiconfiguration', {
                    ...formValue,
                    Key: formValue?.Key?.trim(),
                    SecretKey: formValue?.SecretKey?.trim()
                });
                if (data?.status) {
                    handleClearButton();
                    getapiconfigurationlist();
                    dispatch({ type: 'ALERTING', message: data?.message })
                    dispatch(loaderActions.end());
                }
                else {
                    dispatch(loaderActions.end());
                    dispatch({ type: 'ALERTING', message: data?.message })
                    return;
                }
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
        dispatch(loaderActions.end());
    }

    const handleClearButton = () => {
        setFormError({});
        setEditDisable(false);
        setSearchDisable(false);
        setActiveId(true);
        setValidApi(false)
        setFormValue((prev) => (
            {
                ...prev,
                APIConfigurationId: 0,
                SupplierId: 0,
                URL: '',
                Key: '',
                SecretKey: '',
                IsActive: false,
                UserId: userId?.userMasterID,
                OperatorId: [],
                TravelCategoryId: 1,
                type: 'add'
            }
        ))
    }
    const onEditorView = async (data, type) => {
        setSearchDisable(true)
        setEditDisable(true)
        dispatch(loaderActions.start());
        const statusoftoken = await verifytoken();
        if (statusoftoken) {
            const apiconfigurationbyid = await getAllData(`/master/v1/getapiconfigurationbyid?apiconfigurationid=${data?.APIConfigurationId}`);
            setFormError({});
            if (apiconfigurationbyid?.status) {
                const apiConfiguration = apiconfigurationbyid?.data?.apiConfiguration?.[0]
                const operatorList = apiconfigurationbyid?.data?.operatorList
                setFormValue((prev) => (
                    {
                        ...prev,
                        APIConfigurationId: apiConfiguration?.APIConfigurationId,
                        SupplierId: apiConfiguration?.SupplierId,
                        URL: apiConfiguration?.URL,
                        Key: apiConfiguration?.Key,
                        SecretKey: apiConfiguration?.SecretKey,
                        IsActive: apiConfiguration?.IsActive,
                        UserId: userId?.userMasterID,
                        OperatorId: operatorList?.length > 0 ? operatorList?.map(id => id?.OperatorsId) : [],
                        TravelCategoryId: 1,
                        type: type,
                    }
                ))
                setActiveId(apiConfiguration?.IsActive)
                setValidApi(false);
                setIsDisableValidbtn(true);
            }
        } else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            dispatch(loaderActions.end());
        }
        dispatch(loaderActions.end());
    }

    const columns = [
        {
            name: 'Supplier',
            key: 'SupplierName',
            sortable: true,
            float: "left",
            selector: (data) => data?.SupplierName,
        },
        {
            name: 'Active',
            key: 'Status',
            sortable: true,
            float: "left",
            selector: (data) => data?.Status,
        },
        {
            name: 'Created Date',
            key: 'CreatedDateFormat',
            sortable: true,
            float: "left",
            selector: (data) => new Date(data?.CreatedDate),
            format: (data) => data?.CreatedDateFormat,
        },
        {
            name: 'Edit',
            selector: data => <button type='button' className='border-0 p-0 bg-body set_disableclr' onClick={() => onEditorView(data, 'edit')} disabled={!useredit}
            ><i className="fa fa-edit eye-icon"></i></button>
        },
        {
            name: 'View',
            selector: data => <button type='button' className='border-0 p-0 bg-body set_disableclr' onClick={() => onEditorView(data, 'view')} ><i className="fa fa-eye" ></i></button>
        },
        {
            name: 'Download',
            selector: data => <button type='button' className='border-0 p-0 bg-body set_disableclr' onClick={() => onDownload(data)} disabled={!userexport}><i class="fa-solid fa-download"></i></button>
        }
    ]


    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return date ? [day, month, year].join('/') : '';
    }

    const onDownload = (data) => {
        setShow(true);
        setDowloadDate({
            startDate: '',
            endDate: ''
        })
    }

    const calenderchange = (e) => {
        setDowloadDate({ ...downloadDate, startDate: formatDate(e?.[0]), endDate: formatDate(e?.[1]) })
    }

    const downloadExcel = () => {
        ExportToExcel(downloadDate?.startDate, downloadDate?.endDate);
        setShow(false);
        setDowloadDate({
            startDate: '',
            endDate: ''
        })
    }
    const objfilter = useMemo(() => filterData?.filter(el => formatDate(el?.CreatedDate) >= downloadDate?.startDate && formatDate(el?.CreatedDate) <= downloadDate?.endDate), [downloadDate?.startDate, downloadDate?.endDate]);

    const ExportToExcel = (startDate, endDate) => {
        if (startDate && endDate) {
            const dispalyname = ['Supplier', 'Status', 'Created Date'];
            const fields = ['SupplierName', 'Status', 'CreatedDate'];
            ExportExcel(dispalyname, fields, objfilter, "ActivitiesReport", "ActivitiesReport.xls");
        }
    }

    const modlabody = () => {
        return (
            <div class="mb-3 row mx-1">
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="row">
                        <div className='col-lg-12 col-sm-12 '>
                            <div className='row'>
                                <div class="col-lg-5 col-md-6 mb-1">
                                    <label htmlFor="inputPassword6" class="col-form-label">From</label>
                                </div>
                                <div class="col-lg-5 col-md-6 mb-1">
                                    <label htmlFor="inputPassword6" class="col-form-label">To</label>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-12 col-sm-12'>
                            <div className='row'>
                                <div class="col-lg-9 mb-1 col-md-12">
                                    <RangePicker
                                        value={[
                                            downloadDate?.startDate ? dayjs(downloadDate.startDate, 'DD/MM/YYYY') : null,
                                            downloadDate?.endDate ? dayjs(downloadDate.endDate, 'DD/MM/YYYY') : null,
                                        ]}
                                        className='antd_input'
                                        format={'DD/MM/YYYY'}
                                        style={{
                                            width: '100%',
                                        }}
                                        onCalendarChange={calenderchange}
                                    />
                                </div>
                                <div class="col-lg-3 mb-1 col-md-12">
                                    <button class="btn btn-primary mx-1 form-control" id="btnAdd" type='button'
                                        onClick={downloadExcel}
                                        disabled={(!objfilter?.length > 0) || !useredit}
                                    >Download</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>)
    }

    useEffect(() => {
        async function fetchData() {
            dispatch(loaderActions.start());
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                Promise.allSettled([
                    getoperatorlist(),
                    getapiconfigurationlist()
                ])
                dispatch(loaderActions.end());
            }
            else {
                dispatch(loaderActions.end());
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
        fetchData();
    }, [])

    return (
        <>
            <CustomModal
                show={show}
                size='md'
                onHide={() => setShow(false)}
                modaltitle='Download report'
                modalbody={modlabody}
                modalfooter=''
            />
            <form action="" >
                <div class="mb-3 row mx-1">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <div class="row">
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-4 col-md-12 mb-1">
                                        <label htmlFor="inputPassword6" class="col-form-label required">Select Supplier</label>
                                    </div>
                                    <div class="col-lg-8 mb-1 col-md-12">
                                        <Select
                                            id="SupplierId"
                                            className="dropdown select_dropdown "
                                            options={dropdownData?.supplierList}
                                            value={dropdownData?.supplierList?.filter((val) => (val.value === formValue?.SupplierId))}
                                            onChange={(e) => handleOnChange('SupplierId', e?.value)}
                                            isDisabled={formValue?.type === 'edit' || formValue?.type === 'view' || validapi && !formError?.SupplierId}
                                            isSearchable
                                        />
                                        {formError?.SupplierId && <p className='text-danger text-start mb-0'>{formError?.SupplierId}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-4 col-md-12 mb-1">
                                        <label htmlFor="inputPassword6" class="col-form-label required">Activity Category</label>
                                    </div>
                                    <div class="col-lg-8 mb-1 col-md-12">
                                        <Select
                                            id="SupplierId"
                                            isMulti
                                            className="dropdown select_dropdown operators-List"
                                            options={dropdownData?.operatorList}
                                            value={dropdownData?.operatorList?.filter((val) => formValue?.OperatorId?.includes(val.value)) || []}
                                            onChange={(e) => handleOnChange('OperatorId', e)}
                                            isDisabled={formValue?.type === 'view'}
                                            isSearchable
                                        />
                                        {formError?.OperatorId && <p className='text-danger text-start mb-0'>{formError?.OperatorId}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-4 col-md-12 mb-1">
                                        <label htmlFor="inputPassword6" class="col-form-label required">API Accessing URL</label>
                                    </div>
                                    <div class="col-lg-8 mb-1 col-md-12">
                                        <input type="text" id="FlightNo" class="form-control"
                                            name="URL"
                                            value={formValue?.URL}
                                            maxLength={100}
                                            onChange={(e) => handleOnChange(e?.target?.name, e?.target?.value)}
                                            disabled={formValue?.type === 'view' || validapi}
                                            placeholder="API Accessing URL"
                                        />
                                        {formError?.URL && <p className='text-danger text-start mb-0'>{formError?.URL}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-4 col-md-12 mb-1">
                                        <label for="inputPassword6" class="col-form-label">Active</label>
                                    </div>
                                    <div class="col-auto col-lg-8" disabled={false}>
                                        <Switch
                                            onChange={handleisActive}
                                            checked={activeId}
                                            className="react-switch"
                                            disabled={formValue?.type === 'view'}
                                        />
                                    </div>
                                    <div class=" col-auto col-lg-4">
                                        <ConfirmationModal
                                            show={modalShow}
                                            onHide={() => setModalShow(false)}
                                            noconfirm={() => handleConfirmation(false)}
                                            yesconfirm={() => handleConfirmation(true)}
                                        />

                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-4 col-md-12 mb-1">
                                        <label for="inputPassword6" class="col-form-label required">API Consumer Key</label>
                                    </div>
                                    <div class="col-lg-8 mb-1 col-md-12">
                                        <input type="text" id="FlightNo" class="form-control"
                                            name="Key"
                                            value={formValue?.Key}
                                            maxLength={100}
                                            onChange={(e) => handleOnChange(e?.target?.name, e?.target?.value)}
                                            disabled={formValue?.type === 'view' || validapi}
                                            placeholder="API Consumer Key"
                                        />
                                        {formError?.Key && <p className='text-danger text-start mb-0'>{formError?.Key}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '></div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-4 col-md-12 mb-1">
                                        <label for="inputPassword6" class="col-form-label required">API Consumer Secret Key</label>
                                    </div>
                                    <div class="col-lg-8 mb-1 col-md-12">
                                        <input type="text" id="FlightNo" class="form-control"
                                            name="SecretKey"
                                            value={formValue?.SecretKey}
                                            maxLength={100}
                                            onChange={(e) => handleOnChange(e?.target?.name, e?.target?.value)}
                                            disabled={formValue?.type === 'view' || validapi}
                                            placeholder="API Consumer Secret Key"
                                        />
                                        {formError?.SecretKey && <p className='text-danger text-start mb-0'>{formError?.SecretKey}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-4 col-md-12 mb-1 d-lg-none invisible">
                                        <label for="inputPassword6" class="col-form-label required"></label>
                                    </div>
                                    <div class="col-lg-2 mb-1 col-md-4">
                                        <button class="btn btn-primary mx-1 form-control" id="btnAdd" type='button'
                                            onClick={validate}
                                            disabled={!useredit || formValue?.type === 'view' || validapi || isDisabledValidbtn}
                                        >Validate</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-3 d-flex justify-content-center">
                    {
                        formValue?.type === 'edit'
                            ? (
                                <button class="btn btn-primary mx-1" type='button'
                                    onClick={() => handleAddUpdateData()}
                                    disabled={editDisable || !useredit || !isDisabledValidbtn}
                                >
                                    Update
                                </button>
                            )
                            : (
                                <button class="btn btn-primary mx-1" type='button'
                                    onClick={() => handleAddUpdateData()}
                                    disabled={(formValue?.type === 'view' ? editDisable : false) || !useradd}
                                >
                                    Add
                                </button>
                            )
                    }
                    <button type="button" className="btn btn-primary mx-1" id="btnClear" onClick={handleClearButton}>Clear</button>
                </div>
                <CommonFilter
                    columns={columns}
                    filterList={filterData}
                    searchDisabled={searchDisabled}
                    getdata={getapiconfigurationlist}
                    setlistdata={setGetListData}
                    searchvalue={searchvalue}
                    setSearchValue={setSearchValue}
                    searchby={searchby}
                    setSerachBy={setSerachBy}
                />

                <CustomTable
                    className={'last_three_column_freeze'}
                    columns={columns}
                    data={getDataList}
                    PdfExport={false}
                    ExportToExcel={false}
                    disabled={!userexport}
                />
            </form>
        </>
    )
}

export default APIConfigurationActivity